import React from "react";
import { useTranslation } from "react-i18next";
import { GitMerge } from "lucide-react";

/**
 * Marks a stock count in the main table as the result of a merge.
 * Icon only — the origins themselves are listed in the expanded row's tree.
 *
 * Rendered as a plain <span> on purpose, so the click still bubbles up to the cell
 * and toggles the collapse.
 */
export default function MergeIndicator() {
    const { t } = useTranslation("", { keyPrefix: "inventory.stockCount.main.merge" });

    return (
        <span
            className="inline-flex items-center rounded-[6px] bg-badge-purple p-[4px] text-accent"
            aria-label={t("badge.ariaLabel")}
        >
            <GitMerge size={14} />
        </span>
    );
}
